import { render } from "./SimpleRegisterModal.vue?vue&type=template&id=ff008ba6&scoped=true"
import script from "./SimpleRegisterModal.vue?vue&type=script&lang=js"
export * from "./SimpleRegisterModal.vue?vue&type=script&lang=js"

import "./SimpleRegisterModal.vue?vue&type=style&index=0&id=ff008ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff008ba6"]])

export default __exports__